<template>
  <div class="vcl-link-confirmation">
    <div class="vcl-logon__rounded-icon">
      <vp-icon icon="email" class="rounded-icon__email" />
    </div>
    <h3 class="vcl-logon__title">{{ title ? localizeContent(title) : $t('checkEmail') }}</h3>
    <p class="vcl-logon__description vcl-logon__description--center" style="margin-bottom: 64px">{{ message ? localizeContent(message) : $t('magicLink') }}</p>
    <a v-if="backButton" class="vcl-logon__link" tabindex="0" @click="goBack" @keyup.enter="goBack">{{ $t('signInPassword') }}</a>
  </div>
</template>

<script>
// General Components
import VpIcon from '../../components/vp-icon/VpIcon.vue';

export default {
  name: 'VpLogonSuccess',
  components: {
    VpIcon,
  },
  inject: ['$busy'],
  data() {
    return {
      title: null,
      message: null,
      backButton: true,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$busy.on(true);
      const { backButton = true, title = null, message = null } = this.$route.query;
      this.title = title;
      this.message = message;
      this.backButton = backButton && backButton !== 'false';

      this.$busy.on(false);
    },
    goBack() {
      this.$router.push('/logon#password');
    },
    localizeContent(contentString = '') {
      if (String(contentString).startsWith('i18n:')) {
        const [_, localizedKey] = String(contentString).split(':');
        const localizedValue = this.$i18n.t(localizedKey);
        if (localizedValue) {
          return localizedValue;
        }
        return localizedKey;
      }
      return contentString;
    },
  }
};
</script>

<style lang="scss">
@import "../../styles/mixins.scss";

.vcl-link-confirmation {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 50px 30px;
  @include Tablet {
    padding: 65px 70px 65px;
  }
}
</style>
